export default "__VITE_ASSET__DzW_plhJ__"